/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Bonisoft Backend API
 * Bonisoft Backend API
 * OpenAPI spec version: 1
 */

export type ReportFileFormat = typeof ReportFileFormat[keyof typeof ReportFileFormat];


export const ReportFileFormat = {
  CSV: 'CSV',
  XLSX: 'XLSX',
  PDF: 'PDF',
} as const;
